// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Pg_0_2_avatarContainer__MlBoN","memberQrBar":"Pg_0_2_memberQrBar__2t7ss"};